import { Pipe, PipeTransform } from '@angular/core';
import { Numbers } from '../../common/util/numbers';

@Pipe({ name: 'conversionNumberUnit' })
export class NumberUnitPipe implements PipeTransform {
  transform(obj: any, args?: any): any {
    return Numbers.conversionUnit(obj, 1);
  }
}
